import React from 'react';

const PILLARS = [
  {
    icon: '💸',
    stat: '40%',
    title: 'Cheaper on Average',
    desc: 'Our fare comparison engine scans 100+ airlines in real time so you always pay the lowest available price — guaranteed.',
    color: 'from-amber-500 to-yellow-400',
    bg: 'bg-amber-50',
    border: 'border-amber-100',
  },
  {
    icon: '⚡',
    stat: '60s',
    title: 'Booking in 60 Seconds',
    desc: 'From search to confirmed ticket — our streamlined checkout is the fastest in the industry. No endless forms.',
    color: 'from-violet-600 to-purple-500',
    bg: 'bg-violet-50',
    border: 'border-violet-100',
  },
  {
    icon: '🛡️',
    stat: '100%',
    title: 'Secure & Transparent',
    desc: 'Bank-grade 256-bit SSL encryption. What you see is what you pay — zero hidden charges, zero surprises at checkout.',
    color: 'from-purple-600 to-violet-700',
    bg: 'bg-purple-50',
    border: 'border-purple-100',
  },
];

const FEATURES = [
  { icon: '📱', text: 'Instant e-ticket on WhatsApp & Email' },
  { icon: '🔄', text: 'Easy cancellation & date changes' },
  { icon: '🌍', text: 'International & domestic routes' },
  { icon: '🎒', text: 'Baggage add-ons at checkout' },
  { icon: '🧾', text: 'GST invoice for business travelers' },
  { icon: '🏷️', text: 'Student & senior discounts available' },
];

export default function WhyChooseUs() {
  return (
    <section className="py-14 sm:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Header */}
        <div className="text-center mb-10 sm:mb-14">
          <span className="inline-block text-xs font-bold text-violet-600 uppercase tracking-widest bg-violet-50 border border-violet-100 px-4 py-1.5 rounded-full mb-3">
            Why FlightBooKaro
          </span>
          <h2 className="text-3xl sm:text-4xl font-black text-gray-900 mb-3">
            Travel Smarter.<br className="sm:hidden" /> Save Bigger.
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-sm sm:text-base">
            We built FlightBooKaro for travelers who deserve the best fares without the hassle.
          </p>
        </div>

        {/* 3 pillars */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 sm:gap-6 mb-12">
          {PILLARS.map(p => (
            <div key={p.title} className={`${p.bg} ${p.border} border rounded-2xl p-6 sm:p-8 text-center hover:shadow-lg transition-all duration-300`}>
              <div className={`w-16 h-16 bg-gradient-to-br ${p.color} rounded-2xl flex items-center justify-center text-2xl mx-auto mb-4 shadow-lg`}>
                {p.icon}
              </div>
              <div className="text-4xl font-black text-gray-900 mb-1">{p.stat}</div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{p.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{p.desc}</p>
            </div>
          ))}
        </div>

        {/* Feature grid */}
        <div className="bg-gradient-to-br from-[#1e1b4b] to-purple-900 rounded-3xl p-6 sm:p-10">
          <p className="text-center text-white/60 text-xs font-bold uppercase tracking-widest mb-6">Everything included, nothing extra</p>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 sm:gap-4">
            {FEATURES.map(f => (
              <div key={f.text} className="flex items-center gap-3 bg-white/8 border border-white/10 rounded-xl px-4 py-3">
                <span className="text-xl shrink-0">{f.icon}</span>
                <span className="text-white/80 text-xs sm:text-sm font-medium leading-snug">{f.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
